<script context="module">

    let USER_AGENT = navigator.userAgent;

    import {
        getLocalSessionId
    } from "../utils/session"

    export const getMembersList = async () => {

        return fetch(window.apiUrl + '/admin/members/list', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getMember = async (memberId) => {

        return fetch(window.apiUrl + '/admin/members/get', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'memberid': memberId
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const createMember = async (name, contact, address, external) => {

        return fetch(window.apiUrl + '/admin/members/create', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'name': name,
                'contact': contact,
                'address': address,
                'external': external
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const saveMember = async (memberId, member) => {

        return fetch(window.apiUrl + '/admin/members/save', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'memberid': memberId,
                'member': member
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const deleteMember = async (memberId) => {

        return fetch(window.apiUrl + '/admin/members/delete', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'memberid': memberId
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const deleteUser = async (userId) => {

        return fetch(window.apiUrl + '/admin/users/delete', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'userid': userId
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getUsersList = async () => {

        return fetch(window.apiUrl + '/admin/users/list', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getUser = async (userId) => {

        return fetch(window.apiUrl + '/admin/users/get', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'userid': userId
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const createUser = async (email, fullname, passwd, memberid, level, role) => {

        return fetch(window.apiUrl + '/admin/users/create', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'email': email,
                'fullname': fullname,
                'passwd': passwd,
                'memberid': memberid,
                'level': level,
                'role': role
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const saveUser = async (userId, status) => {

        return fetch(window.apiUrl + '/admin/users/save', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'userid': userId,
                'status': status
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const sessionCheck = async () => {

        return fetch(window.apiUrl + '/auth/session', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            }

        }).then((response) => {

            return response.json()

        }).then((data) => {

            if (data['status'] !== 'success') {

                return false;
            }

            return data['verified'];

        });
    }

    export const loginUser = async (email, password) => {

        return fetch(window.apiUrl + '/auth/login', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
            },

            body: JSON.stringify({
                'email': email,
                'password': password
            })

        }).then((response) => {

            return response.json()

        }).then((data) => {

            return data
        })
    }

    export const getResetCode = async (email) => {

        return fetch(window.apiUrl + '/auth/reset/code', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
            },

            body: JSON.stringify({
                'email': email,
            })

        }).then((response) => {

            return response.json()

        }).then((data) => {

            return data
        })
    }

    export const saveResetPassword = async (code, password, email) => {

        return fetch(window.apiUrl + '/auth/reset/save', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
            },

            body: JSON.stringify({
                'email': email,
                'code': code,
                'password': password
            })

        }).then((response) => {

            return response.json()

        }).then((data) => {

            return data
        })
    }

    export const getPayoutsList = async (dateRange) => {

        return fetch(window.apiUrl + '/admin/payout/prepare', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'start': dateRange['start'],
                'end': dateRange['end']
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const createPayout = async (dateRange, members) => {

        return fetch(window.apiUrl + '/admin/payout/create', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'start': dateRange['start'],
                'end': dateRange['end'],
                'memberids': members
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getPayoutsCount = async () => {

        return fetch(window.apiUrl + '/admin/payout/count', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getDashboard = async (pastDate, currentDate, firstDayMonth, lastDayMonth) => {

        return fetch(window.apiUrl + '/admin/dashboard', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'pastdate': pastDate,
                'currentdate': currentDate,
                'firstdaymonth': firstDayMonth,
                'lastdaymonth': lastDayMonth
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });
    }


    export const getDashboardv2 = async (data) => {

        return fetch(window.apiUrl + '/admin/dashboardv2', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'selected': data['selected'],
                'year': data['year'],
                'start': data['start'],
                'end': data['end']
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });
    }

    export const getExpenseSettings = async () => {

        return fetch(window.apiUrl + '/settings/get', {

            method: 'get',

            headers: {
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const updateExpenseSettings = async (settings) => {

        return fetch(window.apiUrl + '/settings/update', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({
                'projectsettings': settings
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    }

    export const downloadMemberCSV = async () => {

        return fetch(window.apiUrl + '/admin/members/csv', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },

            body: JSON.stringify({})

        }).then((response) => {

            return response.blob();

        }).then((blob) => {

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'managementUsers.csv';

            // Append the link to the body and trigger the download
            document.body.appendChild(link);
            link.click();

            // Remove the link from the body
            document.body.removeChild(link);

        });

    }

    export const downloadRedeemCSV = async () => {

        return fetch(window.apiUrl + '/admin/redeemed/csv', {

            method: 'get',

            headers: {
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },


        }).then((response) => {

            return response.blob();

        }).then((blob) => {

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'ab-transaktionen.csv';

            // Append the link to the body and trigger the download
            document.body.appendChild(link);
            link.click();

            // Remove the link from the body
            document.body.removeChild(link);

        });

    }

    export const downloadTurnoverCSV = async () => {

        return fetch(window.apiUrl + '/admin/turnover/csv', {

            method: 'get',

            headers: {
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': getLocalSessionId()
            },


        }).then((response) => {

            return response.blob();

        }).then((blob) => {

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'ab-umsatz.csv';

            // Append the link to the body and trigger the download
            document.body.appendChild(link);
            link.click();

            // Remove the link from the body
            document.body.removeChild(link);

        });

    }

</script>
